import React from 'react';
import { Link } from 'react-router-dom';
import { FaHeartbeat, FaFlask, FaUserMd } from 'react-icons/fa';
import '../styles/Home.css';
import Doctor from '../../assets/Doctor.jpg';
import treatment1 from '../../assets/about-img-1.png';
import treatment2 from '../../assets/about-img-2.png';
import treatment3 from '../../assets/about-img-3.png';
import Physio from '../../assets/Physio.png';
import HeroCarousel from '../HeroCarousel';
import PatientTestimonials from '../PatientTestimonials';
import GoogleReviews from '../GoogleReviews';


const Home = () => {
  return (
    <div className="homepage">
      <HeroCarousel /> {/* ✅ Carousel at top */}

      {/* HERO SECTION */}
      <section className="hero">
        <div className="hero-text">
          <h1>
            Destination<br />
            For Relief <span>& Wellness</span>
          </h1>
          <p><b>Welcome to SAARTHI</b>, specializing in neurological physiotherapy to help you recover, regain strength, and improve your quality of life.</p>
          <Link to="/appointment">
            <button>Book Your Physiotherapy Consultation</button>
          </Link>
        </div>
        <div className="hero-image">
          <img src={Doctor} alt="Doctor" />
        </div>
        <div className="hero-stats">
          <div><h3>Dr. Aishwarya Joshi</h3><p>Specialized Physiotherapist</p></div>
          <div><h3>4+</h3><p>Years of Clinical Experience</p></div>
          <div><h3>100+</h3><p>Patients Recovered</p></div>
        </div>
      </section>

      {/* PARTNERS
      <section className="partners">
        <h4>Our Trusted Partners</h4>
        <div className="logos">
          <span>Logoipsum</span>
          <span>Logoipsum</span>
          <span>Logoipsum</span>
          <span>Logoipsum</span>
        </div>
      </section> */}

      {/* ABOUT SECTION */}
      <section className="about">
        <div className="about-text">
          <h2>Dedicated to Your Recovery & Enhanced Well-being</h2>
          <p>At SAARTHI, we are committed to empowering your journey to recovery. Our dedicated team provides advanced neurological physiotherapy, crafting personalized treatment plans that integrate the latest techniques with compassionate support to restore your function and enhance your daily living.</p>
          <div className="vision-mission">
            <div><h4>Vision</h4><p>To empower every individual to achieve their fullest physical potential and live a life free from limitations, fostering a healthier and more active community.</p></div>
            <div><h4>Mission</h4><p>To support our patients through every stage of their rehabilitation with expert guidance and a nurturing environment, fostering their growth towards greater independence and improved physical health.</p></div>
          </div>
        </div>
        <div className="about-images">
          <img src={treatment1} alt="treatment-1" />
          <img src={treatment2} alt="treatment-2" />
          <img src={treatment3} alt="treatment-3" />
        </div>
      </section>

      {/* SERVICES */}
      <section className="services">
        <h3>We Provide The Best Services</h3>
        <div className="service-cards">
          <div className="card">
            <h4>Injury Rehabilitation</h4>
            <p>Personalized rehab programs for sports injuries.</p>
            <Link to="/services">
              <button>Learn More</button>
            </Link>
          </div>
          <div className="card">
            <h4>Neurological Rehabilitation</h4>
            <p>Helping individuals regain functional independence.</p>
            <Link to="/services">
              <button>Learn More</button>
            </Link>
          </div>
          <div className="card">
            <h4>Orthopedic Rehabilitation</h4>
            <p>Targeted rehab for bones, joints & mobility.</p>
            <Link to="/services">
              <button>Learn More</button>
            </Link>
          </div>
        </div>
      </section>
      
      {/* Saarthi Difference */}
      <section className="saarthi-difference">
        <h3>The Saarthi Difference</h3>
       <div className="difference-cards">
          <div className="diff-card">
           <FaHeartbeat className="diff-icon" />
            <h4>Technology-Powered Care</h4>
           <p>Live biofeedback, precise diagnosis & algorithm-based treatments ensure faster recovery.</p>
          </div>
          <div className="diff-card">
            <FaFlask className="diff-icon" />
            <h4>Science-Backed Methods</h4>
           <p>We follow protocols validated by global physiotherapy guidelines.</p>
          </div>
          <div className="diff-card">
            <FaUserMd className="diff-icon" />
            <h4>Expert Multi-Specialist Team</h4>
            <p>Physios, neuro specialists, and ortho experts collaborate for your recovery.</p>
          </div>
        </div>
      </section>

      {/* WHY CHOOSE US */}
      <section className="why-choose-us">
        <div className="choose-img">
          <img src={Physio} alt="Physio" />
        </div>
        <div className="choose-text">
          <h3>Personalized Physiotherapy: Your Journey to Renewed Movement</h3>
          <p>At <b>SAARTHI</b>, your progress is our priority. We deliver specialized neurological physiotherapy, employing evidence-based methods and a deeply empathetic approach to help you overcome physical limitations, improve mobility, and reclaim a vibrant, active life.</p>
          <ul>
            <li><b>Expert Neurological Physiotherapists:</b> Led by <b>Dr. Aishwarya Joshi</b> , our clinic is staffed by highly skilled physiotherapists specializing in neurological rehabilitation, ensuring precise and effective care.</li>
            <li><b>Tailored Rehabilitation Programs:</b> Our services span a wide range of neurological conditions, providing customized plans that evolve with your progress and specific needs.</li>
            <li><b>Patient-Centric Treatment Plans:</b> Your care plan is designed around your unique lifestyle and goals, with flexible scheduling options to support consistent progress.</li>
          </ul>
        </div>
      </section>
    
    <PatientTestimonials />
    <GoogleReviews />    
    </div>
  );
};

export default Home;
